import React from "react";
import { Modal, ModalProps } from "antd";
import { ButtonProps } from "antd/lib/button";
import styles from "./index.module.scss";

interface Props extends ModalProps {
  title: React.ReactNode;
  visible: boolean;
  children: React.ReactNode;
  okText?: string;
  onOk?: () => void;
  confirmLoading?: boolean;
  isSaving?: boolean;
  onCancel?: () => void;
  style?: any;
}

export const EComModal = (props: Props) => {
  const {
    title,
    okText,
    visible,
    onCancel,
    confirmLoading,
    isSaving,
    onOk,
    children,
    style,
    okButtonProps,
    cancelButtonProps,
    ...otherProps
  } = props;

  /**
   * The app's button shape, merged under whatever the caller passes rather than replacing it: a
   * caller that only adds `danger` or `disabled` would otherwise lose the shape and render a square
   * button next to a round Cancel. Same reasoning as in components/Modal.
   */
  const toButtonProps = (buttonProps?: ButtonProps): ButtonProps => ({
    shape: "round",
    style: { minWidth: "92px" },
    ...buttonProps,
    disabled: isSaving || buttonProps?.disabled,
  });

  return (
    <Modal
      bodyStyle={{ overflowY: "auto", maxHeight: "70vh" }}
      okButtonProps={toButtonProps(okButtonProps)}
      cancelButtonProps={toButtonProps(cancelButtonProps)}
      centered={true}
      visible={visible}
      title={title}
      okText={okText}
      onCancel={onCancel}
      onOk={onOk}
      confirmLoading={confirmLoading}
      destroyOnClose={true}
      className={style ?? styles.modal}
      {...otherProps}
    >
      {children}
    </Modal>
  );
};
